import { http } from "./http.js";

async function getCountryReference(resource, id) {
  const response = await http.get(`${resource}/referencies/${id}`);
  return { id: response.data.Id, title: response.data.Title };
}

async function getAllCountryReferencies(changedResource) {
  const response = await http.get(`${changedResource}/referencies`);
  return response.data.map(i => {
    return {
      text: i.Title,
      value: i.Id,
    };
  });
}

async function searchCountryReference(changedResource, queryParams) {
  const response = await http.get(
    `${changedResource}/referencies?${queryParams}`,
  );
  if (Array.isArray(response.data)) {
    return response.data.map(i => {
      return {
        text: i.Title,
        value: i.Id,
      };
    });
  } else {
    response.data = [];
    return response.data;
  }
}

async function createFactoryLoadingPlace(
    factoryId,
    addressId,
    timetable,
    contactPerson,
) {
  const response = await http.post(`factories/${factoryId}/loading-places`, {
    addressId,
    timetable,
    contactPersonsIds: contactPerson,
  });
  return response.data;
}

async function getFactoryLoadingPlaceReference(factoryId, createdId) {
  const response = await http.get(
    `factories/${factoryId}/loading-places/referencies/${createdId}`,
  );
  return { id: response.data.Id, title: response.data.Title };
}

async function getFactoryLoadingPlace(id) {
  const response = await http.get(`factories/${id}/loading-places`);
  return response.data.map(i => {
    return {
      text: i.Address.Title,
      value: i.Id,
      countryId: i.Address.Country.Id,
    };
  });
}

async function searchFactoryLoadingPlace(id, queryParams) {
  const response = await http.get(
    `factories/${id}/loading-places?searchTerm=${queryParams}`,
  );
  if (Array.isArray(response.data)) {
    return response.data.map(i => {
      return {
        text: i.Address.Title,
        value: i.Id,
      };
    });
  } else {
    response.data = [];
    return response.data;
  }
}

async function getManagerReference(resource, id) {
  const response = await http.get(`${resource}/referencies/${id}`);
  return {
    id: response.data.Id,
    title: response.data.Title,
    inputLanguage: response.data.InputLanguage,
  };
}

async function getAllManagers(resource) {
  const response = await http.get(`${resource}/work-with-clients`);
  return response.data.map(i => {
    return {
      text: i.Title,
      value: i.Id,
      inputLanguage: i.InputLanguage,
    };
  });
}

async function searchManager(resource, search) {
  const response = await http.get(
    `${resource}/work-with-clients?searchTerm=${search}`,
  );
  if (Array.isArray(response.data)) {
    return response.data.map(i => {
      return {
        text: i.Title,
        value: i.Id,
        inputLanguage: i.InputLanguage,
      };
    });
  } else {
    response.data = [];
    return response.data;
  }
}

async function getNewShipping() {
  const response = await http.get("shippings/new");
  return response.data;
}

async function getNewShippingUkr() {
  const response = await http.get("countries/rpc/by-title/Украина");
  return {
    id: response.data.Id,
    title: response.data.Title,
  };
}

async function getUkraine() {
  const response = await http.get("countries/ukraine");
  return response.data;
}

async function getDraftShipping(id) {
  const response = await http.get(`shipping-drafts/${id}`);
  return response.data;
}

async function createShipping(entity) {
  const response = await http.post("shippings", entity);
  return response.data;
}

async function deleteShippingDraft(id) {
  const response = await http.delete(`shipping-drafts/${id}`);
  return response;
}

async function createShippingDraft(entity) {
  const response = await http.post("shipping-drafts", entity);
  return response.data;
}

async function updateShippingDraft(id, entity) {
  const response = await http.put(`shipping-drafts/${id}`, entity);
  return response;
}

async function createAttachments(id, attachment, draft) {
  const url = draft
    ? `shipping-drafts/${id}/attachments`
    : `shippings/${id}/attachments`;

  const response = await http.post(url, attachment);
  return response;
}

async function updateNewClientAlias(id, alias) {
  const response = await http.patch(`clients/${id}/aliases`, {
    value: alias,
  });
  return response;
}

async function getUnloadingContactPerson(id) {
  const response = await http.get(`contact-persons/${id}`);
  return response.data;
}

async function getFactoryLoadingPlaceAddress(id) {
  const response = await http.get(`factories/${id}/loading-places`);
  return response.data.map(i => {
    return {
      text: i.Address.Title,
      value: i.Address.Id,
    };
  });
}

export {
  getCountryReference,
  getAllCountryReferencies,
  searchCountryReference,
  createFactoryLoadingPlace,
  getFactoryLoadingPlaceReference,
  getFactoryLoadingPlace,
  searchFactoryLoadingPlace,
  getManagerReference,
  getAllManagers,
  searchManager,
  getNewShipping,
  getNewShippingUkr,
  getUkraine,
  getDraftShipping,
  createShipping,
  deleteShippingDraft,
  createShippingDraft,
  updateShippingDraft,
  createAttachments,
  updateNewClientAlias,
  getUnloadingContactPerson,
  getFactoryLoadingPlaceAddress,
};
